module.exports = __webpack_public_path__ + "_/img/MapMarker6.ef8cbf88.svg";